import React, { useState } from 'react';
import { Icon, Dropdown, Menu } from 'antd';
import SmallSpinner from '../../shared/SmallSpinner';


type Props = {
    isCheckButtonLoading?: boolean;
    isDeleteButtonLoading?: boolean;
    onCheckUrlClick: () => void;
    onDeleteUrlClick: (() => void) | undefined;
};


export default function ServiceableUrlsActionCell({ isCheckButtonLoading, isDeleteButtonLoading, onCheckUrlClick, onDeleteUrlClick }: Props) {
    const [isDropdownVisible, setIsDropdownVisible] = useState<boolean>(false);

    const handleCheckUrlClick = () => {
        onCheckUrlClick();
    };

    const isDropdownDisabled = isCheckButtonLoading || isDeleteButtonLoading;

    return (
        <div className="action-button-column">
            <Dropdown
                visible={isDropdownVisible}
                onVisibleChange={setIsDropdownVisible}
                trigger={['click']}
                overlay={
                    <Menu>
                        <Menu.Item
                            key="check"
                            disabled={isDropdownDisabled}
                            onClick={handleCheckUrlClick}
                        >
                            <Icon type="reload" />Recheck
                            {isCheckButtonLoading && <SmallSpinner style={{ marginLeft: '8px' }} />}
                        </Menu.Item>

                        {onDeleteUrlClick && (
                            <Menu.Item
                                key="delete"
                                disabled={isDropdownDisabled}
                                onClick={onDeleteUrlClick}
                            >
                                <Icon type="delete" />Delete
                                {isDeleteButtonLoading && <SmallSpinner style={{ marginLeft: '8px' }} />}
                            </Menu.Item>
                        )}
                    </Menu>
                }
                placement="bottomRight"
            >
                <Icon type='more' style={{ cursor: 'pointer', fontSize: '22px' }} />
            </Dropdown>
        </div>
    );
}
